let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRs6A")).then(() => parcelRequire('d8lGf'));